import styled from 'styled-components'

export const SideBarMenuContainer = styled.div`
  width: fit-content;
  background-color: ${props => props.theme.colors.background.primary};
  box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.14);
  height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  max-width: 248px;
`
